import { render } from "./InformationBox.vue?vue&type=template&id=261e920e&scoped=true"
import script from "./InformationBox.vue?vue&type=script&lang=js"
export * from "./InformationBox.vue?vue&type=script&lang=js"

import "./InformationBox.vue?vue&type=style&index=0&id=261e920e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261e920e"]])

export default __exports__